import React from 'react';
import { Input } from '../../ui/input';

const GIORNI = ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'];

export const TurnoOperatore = ({ f, nomi, onCambia }) => {
  const toggle = (i) => onCambia('giorni_liberi', f.giorni_liberi.includes(i) ? f.giorni_liberi.filter((x) => x !== i) : [...f.giorni_liberi, i]);
  return (
    <div className="space-y-2" data-testid="pulizie-compila-turno">
      <datalist id="pulizie-compila-nomi">{nomi.map((n) => <option key={n} value={n} />)}</datalist>
      <label className="block text-xs font-medium">Chi ha pulito
        <Input list="pulizie-compila-nomi" value={f.operatore} maxLength={60} onChange={(e) => onCambia('operatore', e.target.value)}
          className="h-11" data-testid="pulizie-compila-operatore" />
      </label>
      <div>
        <p className="text-xs font-medium">Il suo giorno libero</p>
        <div className="mt-1 flex gap-1">
          {GIORNI.map((g, i) => (
            <button key={g} onClick={() => toggle(i)} data-testid={`pulizie-compila-libero-${g.toLowerCase()}`}
              className={`flex-1 h-9 rounded-lg text-xs font-medium border transition-colors ${f.giorni_liberi.includes(i) ? 'bg-amber-500 border-amber-500 text-white' : 'border-gray-300 hover:bg-gray-100'}`}>
              {g}
            </button>
          ))}
        </div>
      </div>
      {f.giorni_liberi.length > 0 && (
        <label className="block text-xs font-medium">Chi lo sostituisce nel giorno libero
          <Input list="pulizie-compila-nomi" value={f.sostituto} maxLength={60} onChange={(e) => onCambia('sostituto', e.target.value)}
            className="h-11" placeholder="Nome e cognome" data-testid="pulizie-compila-sostituto" />
        </label>
      )}
    </div>
  );
};
